import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { Home } from "./Entities/Home";
import { Registro } from "./Entities/Registro";
import { Confirmado } from "./Entities/Confirmado";
import { Login } from "./Entities/Login/Login";
import { ConsultaRegistrados } from "./Entities/Consulta/ConsultaRegistrados";
import { AceptaResponsiva } from "./Entities/AceptaResponsiva";
import { DatosCarrera } from "./Entities/DatosCarrera";
import { ResumenIngresos } from "./Entities/ResumenIngresos";
import { Inicio } from "./Entities/Inicio";
import { Menu } from "./Entities/Menu/Menu";
import { DescargaCarta } from "./Entities/DescargaCarta";
import { CierreEvento } from "./Entities/CierreEvento";
import { Aportaciones } from "./Entities/Aportaciones/Aportaciones";
import { Main } from "./Entities/Main";
import { Exportar } from "./Entities/Consulta/Exportar";
import "rsuite/dist/rsuite.min.css";
import { Provider } from "react-redux";
import store from "./redux/Store";
import { DespacitosMTB } from "./Entities/DespacitosMTB";
import { DatosIniciales } from "./Entities/DatosIniciales";
import { Respuesta } from "./Entities/Respuesta";


function App() {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/" Component={Inicio} />
          <Route path="/Inicio/Main" Component={Main} />
          <Route path="/CierreEvento" Component={CierreEvento} />
          <Route path="/DatosIniciales" Component={DatosIniciales} />
          <Route path="/registro/confirmado/:curp" Component={Confirmado} /> 
          <Route path="/AceptaResponsiva" Component={AceptaResponsiva} />
          <Route path="/AceptaResponsiva/registro/:aceptado/:esTutor" Component={Registro} />
          <Route path="/registro/descargacarta" Component={DescargaCarta} />
          <Route path="/registro/respuesta/:curp" Component={Respuesta} />
          <Route path="/Login" Component={Login} />
          <Route path="/Menu/consultaregistrados" Component={ConsultaRegistrados} />
          <Route path="/Menu/DatosCarrera" Component={DatosCarrera} />
          <Route path="/Aportaciones/DespacitosMTB" Component={DespacitosMTB} />
          <Route path="/Menu/ResumenIngresos" Component={ResumenIngresos} />
          <Route path="/Login/menu" Component={Menu} />
          <Route path="/menu/exportar" Component={Exportar} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
